import { inject, Injectable } from '@angular/core';
import { AppSettingsService } from '@adw/projects/aca-shared/src/public-api';
import { WkAppConfigService } from './wk-app-config.service';

@Injectable({ providedIn: 'root' })
export class WkSettingsService extends AppSettingsService {
  private readonly wkAppConfig = inject(WkAppConfigService);

  /**
   * Get the header color from the app settings.
   */
  public get headerColor(): string {
    return this.wkAppConfig.get<string>('header.color', '#2196F3');
  }
}
